import {Fragment} from "react";

export default function NsRightClickMenu({
                                             voci,
                                             points,
                                             show,
                                             elemento
                                         }) {


    return (
        show === true &&
        <div top={points.y} left={points.x} className={'ns-rc-menu-container'} style={{
            top: points.y,
            left: points.x
        }}>
            <div className={"text-center ns-rc-menu-header"}>
                <span><strong>{elemento.descrizione}</strong></span>
            </div>
            <ul>
                {
                    voci && voci.map((voce, idx) =>
                        <li
                            onClick={() => {
                                if (voce.fun) {
                                    voce.fun(elemento);
                                }
                            }}
                            key={idx}
                        >
                            {
                                voce.icon && voce.icon !== '' &&
                                <Fragment><i className={voce.icon}/>&nbsp;</Fragment>
                            }
                            {voce.title}
                        </li>
                    )
                }
            </ul>
        </div>
    )
}